<template>
  <v-card width="100%" height="100%" flat>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-envelope</v-icon>
      Contact Us:
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <!-- <v-col cols="12" class="subtitle-1">
            If you have questions or concerns we invite you to contact The Mount office:
            <br>
            <u>Email:</u> hello@themountcc.org
            <br>
            <u>Phone:</u> 859.824.4093
          </v-col> -->
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="name"
              label="Name"
              outlined
              :rules="rules.required"
              color="black"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="phone"
              label="Phone"
              outlined
              v-mask="phoneMask"
              :rules="rules.required"
              color="black"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="email"
              label="Email"
              :rules="rules.email"
              outlined
              color="black"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="msg"
              label="Message"
              :rules="rules.required"
              outlined
              color="black"
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn outlined large @click="sendMail()" :disabled="readyToSend">
              <v-icon left>far fa-paper-plane</v-icon>
              Send
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask'
import mixins from '@/plugins/mixins.js'
export default {
  directives: {mask},
  mixins: [mixins],
  data(){
    return {
      name  : "",
      phone : "",
      email : "",
      msg   : ""
    }
  },
  methods: {
    sendMail(){
      let msgData = {
        cc          : this.email,
        email       : this.getSettings,
        msg         : this.msg,
        name        : this.name,
        phone       : this.phone,
        subject     : 'A new contact from The Mount Forms Online.',
        successMsg  : "Thank you for contacting The Mount Office. You should find a copy in the email address you provided."
      }
      this.$store.dispatch('sendMsg', msgData)
    }
  },
  computed: {
    getSettings(){
      return this.$store.getters.getSettingsEmail.value
    },
    readyToSend(){
      if (this.name && this.phone && this.email && this.msg) {
        return false
      }
      else {
        return true
      }
    }
  }
}
</script>
